// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import Icon from 'components/Icon';
import { sendEvent } from 'lib/analytics';

// local
import styles from './ContactButton.pcss';

// {/* { '877-346-0640' } */}

export default class ContactButton extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
  }
  static defaultProps = {}
  
  handleClick = () => sendEvent('call')
  
  render() {
    const { className } = this.props;
    const classNames = classnames(className, styles.contactButton);
    return (
      <a
        href={ 'tel:503-346-0640' }
        onClick={ this.handleClick }
        className={ classNames }
        title={ 'Call Doctor Seideman' }
      >
        <Icon type={ 'phone' } />
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactButton/index.jsx